import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import * as ActionTypes from '../../../../constants/ActionTypes';
import { WrapColorPicker } from '../../../widgets/index';
import CSSLength from '../../../../../lib/css-property-parser/CSSLength';

class DisabledButtonPreview extends Component {
    render() {
        const fontSize = new CSSLength(this.props.data.fontSize, {
            base: 16,
            formatter: (value, unit) => value + unit
        });
        const borderRadius = new CSSLength(this.props.data.borderRadius, {
            base: 16,
            formatter: (value, unit) => value + unit
        });
        const fontSize2 = fontSize.px;
        const fontSize3 = Math.round(fontSize2.substring(0, fontSize2.length - 2)) + 'px';
        const borderRadius2 = borderRadius.px;
        const borderRadius3 = Math.round(borderRadius2.substring(0, borderRadius2.length - 2)) + 'px';
        return (
            <div className="ButtonPreview">
                <h4>{this.props.tagNameName}</h4>
                <p>{this.props.tag}</p>
                <div className="row">
                    <div className="col-lg-2 col-xs-12 col-sm-4">
                        <div
                            className={`add-to-cart-button ${this.props.isDisabled ? 'disabled' : ''}`}
                            style={{
                                background: this.props.colors.background,
                                // borderColor: this.props.data.border.normal,
                                border: this.props.colors.border,
                                color: this.props.colors.color,
                                //borderStyle: this.props.buttonPreview.general.style,
                                //borderWidth: this.props.buttonPreview.general.borderWidth,
                                // borderRadius: borderRadius3,
                                fontSize: fontSize3,
                                fontStyle: this.props.data.style,
                                fontWeight: this.props.data.weight,
                                textAlign: 'center',
                                fontFamily: this.props.data.font,
                                textTransform: this.props.data.textTransform
                            }}
                        >
                            Sample DISABLED
                        </div>
                        {/* <WrapColorPicker color={this.props.buttonPreview.borderColor.normal}
                             onColorChange={this.props.onLeafPropertyChange(this.props.layer, "borderColor", "normal")}>
              <span className="spark-icon spark-icon-pencil button-preview-pencil-border"/>
            </WrapColorPicker>
            <WrapColorPicker color={this.props.buttonPreview.backgroundColor.normal}
                             onColorChange={this.props.onLeafPropertyChange(this.props.layer, "backgroundColor", "normal")}>
              <span className="spark-icon spark-icon-pencil button-preview-pencil-background"/>
            </WrapColorPicker>
            <WrapColorPicker color={this.props.buttonPreview.color.normal}
                             onColorChange={this.props.onLeafPropertyChange(this.props.layer, "color", "normal")}>
              <span className="spark-icon spark-icon-pencil button-preview-pencil-text"/>
            </WrapColorPicker> */}
                    </div>
                </div>
            </div>
        );
    }
}

DisabledButtonPreview.defaultProps = {
    isDisabled: false
};

DisabledButtonPreview.propTypes = {
    title: PropTypes.object,
    subtitle: PropTypes.object,
    defaultLink: PropTypes.object,
    largePrice: PropTypes.object,
    tag: PropTypes.string,
    isDisabled: PropTypes.bool
};

const mapStateToProps = state => {
    return { ...state.app.data.theme.button, ...state.theme.button };
};

const mapDispatchToProps = dispatch => {
    return {
        //Generic action that can potentially kill a lot of boiler plate code
        onLeafPropertyChange: (layer, target, leaf) => {
            return event =>
                dispatch({
                    type: ActionTypes.LEAF_PROPERTY_CHANGE,
                    layer: layer,
                    target: target,
                    leaf: leaf,
                    value: event.target.value
                });
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(DisabledButtonPreview);



// WEBPACK FOOTER //
// ./src/components/pages/theme/buttons/DisabledButtonPreview.js